import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Qué incluye exactamente el Pack?',
    a: 'El Pack Básico incluye 4 libros digitales con más de 400 citas y actividades únicas — uno para cada combinación padre/madre e hijo/hija — más 7 bonos exclusivos valorados en $35. El Pack Completo suma 2 libros más: uno para la pareja y uno para actividades de toda la familia.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al completar tu compra recibís acceso inmediato por email. Descarga directa, sin esperas. Podés usarlo desde el teléfono, tablet o computadora en menos de 5 minutos.'
  }, {
    q: '¿Para qué edad son las citas?',
    a: 'El pack está diseñado para niños de 4 a 14 años. Las citas están pensadas para adaptarse a diferentes edades — vos elegís las que mejor funcionan para tus hijos en este momento.'
  }, {
    q: '¿Qué lo hace diferente a otras opciones del mercado?',
    a: 'No es una lista de actividades genéricas. Es un sistema completo con intención emocional detrás de cada cita. Cada momento está diseñado para abrir conversaciones reales, fortalecer el vínculo y crear recuerdos que tus hijos van a llevar toda la vida. No es contenido. Es una experiencia.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si no te convence, escribís un mensaje y te devolvemos el 100%. Sin preguntas. La tasa de devolución es menor al 1% porque quienes lo prueban con sus hijos... no lo devuelven.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-57">
      <div className="max-w-3xl mx-auto" data-id="element-58">
        <div className="text-center mb-12" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-60">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, index) => <div key={index} className="bg-navy-900 border border-navy-800 rounded-2xl overflow-hidden transition-colors hover:border-purple-900/50" data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-63">
                <span className="font-semibold text-lg text-white pr-8" data-id="element-64">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-purple-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-65" />
              </button>

              <AnimatePresence data-id="element-66">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-67">
                    <div className="px-6 pb-6 text-slate-300 leading-relaxed border-t border-navy-800/50 pt-4 mt-2" data-id="element-68">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}